import sendToServer from './send-to-server';

const Concierge = {
  init() {
    if (!($('.concierge').length > 0)) return;
    $('.no-idea-sign-up-button').click(this.handleNoIdeaSignUpClick.bind(this));
    $('.no-idea-no-thanks-button').click(this.handleNoIdeaNoSignUpClick.bind(this));
    $('.no-idea-explore-button').click(this.handleExploreClick.bind(this));
    $('.learn-more-favourites-button').click(this.handleLearnMoreFavouritePickClick.bind(this));
    $('.find-job-favourites-button').click(this.handleFindJobFavouritePickClick.bind(this));
    $('.newsletter-prompt-sign-up-button').click(this.handleNewsletterPromptSignUpClick.bind(this));
    $('.newsletter-prompt-no-thanks-button').click(this.handleNewsletterPromptNoSignUpClick.bind(this));
    $('.upcoming-badge-notification-section').click(this.handleBadgeToggleClick);
  },

  handleBadgeToggleClick() {
    $('.upcoming-badge-section').slideToggle();
  },

  handleNoIdeaSignUpClick(event) {
    this.handleSignUpClick(event, '/app/taster/start')
  },

  handleNoIdeaNoSignUpClick() {
    this.handleNoSignUpClick('/app/taster/start');
  },

  handleNewsletterPromptSignUpClick(event) {
    this.handleSignUpClick(event, '/app')
  },

  handleNewsletterPromptNoSignUpClick() {
    this.handleNoSignUpClick('/app');
  },

  handleSignUpClick(event, nextLocation) {
    const button = $(event.target).closest('.action-button');

    if (button.data('requires-email')) {
      $('.email-collector').fadeIn();
      $('.submit-email-button').click(() => this.handleSubmitEmailClick(nextLocation));
    } else {
      this.signUserUp(nextLocation);
    }
  },

  handleNoSignUpClick(nextLocation) {
    sendToServer('/api/v2/me',
                 { newsletter_prompted: true },
                 () => { window.location = nextLocation },
                 'PATCH');
  },

  signUserUp(nextLocation, email) {
    const data = { receive_emails: true, newsletter_prompted: true };
    if (email) data.email = email;

    sendToServer('/api/v2/me',
                 data,
                 () => { this.postInspirationsSignUp(nextLocation) },
                 'PATCH');


  },

  handleSubmitEmailClick(nextLocation) {
    const email = $('.email-field').val();
    $('.email-collector').fadeOut();
    this.signUserUp(nextLocation, email);
  },



  handleExploreClick() {
    sendToServer('/api/v2/me',
                 { onboarding_completed: true },
                 null,
                 'PATCH');
    window.location = '/app/taster/start'
  },

  postInspirationsSignUp(nextLocation) {
    $('.career-inspirations-confirmation').fadeIn(300);
    window.setTimeout(()=> {
      $('.career-inspirations-confirmation').fadeOut(300);
    }, 2000);
    window.location = nextLocation;
  },

  handleLearnMoreFavouritePickClick() {
    this.handleFavouritePickClick('/app/careers/favourite')
  },

  handleFindJobFavouritePickClick() {
    this.handleFavouritePickClick('/app/journal')
  },

  handleFavouritePickClick(nextLocation) {
    const pickedCareerIds = $('.chooseable-careers input:checked').map((_, element) => {
      return $(element).val();
    }).get();

    sendToServer('/api/v2/careers/favourites',
                 { career_ids: pickedCareerIds },
                 () => { this.postFavouriteClick(nextLocation) },
                 'POST');
  },

  postFavouriteClick(nextLocation) {
    sendToServer('/api/v2/me',
                 { onboarding_completed: true },
                 null,
                 'PATCH');
    window.location = nextLocation
  }
};

$(document).ready(()=> {
  Concierge.init();
});
